<app-side-menu>
  
  <div class="profiles-table">
    <app-table
      [title]="'Perfis'"
      [data]="profiles"
      [columns]="columns"
      [loading]="loading"
      [showSearch]="true"
      [searchPlaceholder]="'Pesquisar perfis...'"
      [clickable]="false"
      [disablePagination]="false"
      [totalItemsFromBackend]="totalItems"
      [itemsPerPage]="pageSize"
      [currentPageFromBackend]="currentPage"
      [hasNextPageFromBackend]="currentPage < totalPages"
      [hasPreviousPageFromBackend]="currentPage > 1"
      [actions]="actions"
      (searchChange)="onSearch($event)"
      (pageChange)="onPageChange($event)"
      (pageSizeChange)="onPageSizeChange($event)"
      (actionClick)="handleAction($event)">
      <button
        *appHasPermission="'Profiles.Manage'"
        table-header-action
        class="btn btn-primary new-profile-btn"
        (click)="createProfile()">
        <i class="fas fa-plus me-2"></i>
        Novo Perfil
      </button>
    </app-table>
  </div>
</app-side-menu>
